import AccessTimeIcon from "@mui/icons-material/AccessTime";
import MapIcon from "@mui/icons-material/Map";
import { getEventsToLink } from "apis/ActivityApi";
import { getPostsByProject, getPostsToLink } from "apis/PostServiceApi";
import { getProjectByID, linkEvents, linkPosts } from "apis/ProjectServiceApi";
import CreatePostModal from "components/common/CreatePostModal/CreatePostModal";
import EventDetailModal from "components/common/modals/EventDetailModal";
import ViewPostsModal from "components/common/modals/ViewPostsModal";
import ProjectNavBarBack from "components/layout/navigation/ProjectNavBarBack/ProjectNavBarBack";
import BenevvPopperSelect from "components/popper/BenevvPopperSelect";
import BenevvPopup from "components/popup/BenevvPopup/BenevvPopup";
import { Item } from "components/popup/BenevvPopupEvents/BenevvPopupEvent";
import BenevvPopupEvents from "components/popup/BenevvPopupEvents/BenevvPopupEvents";
import BenevvPopupPosters from "components/popup/BenevvPopupPosters/BenevvPopupPosters";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { RootState, StatusState } from "store/types";
import { Project, IEventData, ProcessedCampaignInfo } from "types";
import DonationDetail from "./DonationDetails/DonationDetail";
import { CenterPageSection, Sections } from "./Project.styles";
import {
  BackButtonContainer,
  ColumnBlock,
  ColumnsContainer,
  EventCardContainer,
  EventInfoContainer,
  EventInfoRow,
  EventInfoText,
  EventTitle,
  GreyCircleButton,
  HeaderContainer,
  MainContainer,
  PlaceholderBox,
  PosterCaption,
  PosterCard,
  PosterImage,
  PosterImageFallback,
  PostersContainer,
  ProjectDate,
  ProjectDescription,
  ProjectTitle,
  SectionContent,
  SectionHeader,
  SectionTitle,
  SeeAllLink,
  StyledEventCard,
  SubSectionTitle,
  TimeIcon,
  TimeRow,
} from "./ProjectDetail/ProjectDetail.styles";
import {
  ProjectDetailSkeletonLayout,
  ProjectHeaderSkeleton,
} from "./ProjectDetailSkeletons";
import FundraisingCard, { FundraisingCardProps } from "components/FundraisingDetails/FundraisingCard";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { fetchProjectById} from "store/projects/projectDetails/projectDetails.actions";
import { selectProjectDetails, selectProcessedData } from "store/projects/projectDetails/projectDetails.selectors";
import { Post as CampaignPostType } from "store/campaigns/campaignPosts/campaignPosts.types";


// -----------------------------------------------------------------------
// TYPES
// -----------------------------------------------------------------------

type ProjectMainBoardProps = {};

export interface PosterItem {
  id: number;
  post_caption: string;
  images: {
    id: number;
    image_url: string;
  }[];
}

interface GroupData {
  data: Array<{
    id: number;
    post_caption: string;
    images: Array<{
      image_url: string;
      post_id: number;
    }>;
  }>;
}

// -----------------------------------------------------------------------
// HELPERS
// -----------------------------------------------------------------------

/*function getDaysLeft(dateString: string): number {
  const targetDate = new Date(dateString);
  const currentDate = new Date();
  targetDate.setHours(0, 0, 0, 0);
  currentDate.setHours(0, 0, 0, 0);
  const diffTime = targetDate.getTime() - currentDate.getTime();
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}*/

// -----------------------------------------------------------------------
// COMPONENT
// -----------------------------------------------------------------------

const ProjectMainBoard: React.FC<ProjectMainBoardProps> = () => {
  const publicUserId = Number(useParams().publicUserId);
  const auth = useAppSelector((state: RootState) => state.auth);
  const { projectId } = useParams();

  const [openEventPopup, setOpenEventPopup] = React.useState(false);
  const [openPosterPopup, setOpenPosterPopup] = React.useState(false);
  const [openDonationDetail, setOpenDonationDetail] = React.useState(false);
  const [isCreatePostOpen, setIsCreatePostOpen] = React.useState(false);
  const [eventsToLink, setEventsToLink] = React.useState<Item[]>([]);
  const [userPosts, setUserPosts] = React.useState<PosterItem[]>([]);
  const [selectedEvent, setSelectedEvent] = React.useState<Item | null>(null);
  const [selectedEventItems, setSelectedEventItems] = React.useState<number[]>(
    []
  );
  const [selectedPosterItems, setSelectedPosterItems] = React.useState<
    number[]
  >([]);
  const navigate = useNavigate();
  // const [selectedFundraisingId, setSelectedFundraisingId] = React.useState<
  //   string | null
  // >(null);
  //const [isLoadingProject, setIsLoadingProject] = React.useState(true);
  // ViewPostsModal
  const [viewPostsModalOpen, setViewPostsModalOpen] = React.useState(false);
  const [allPosts, setAllPosts] = React.useState<PosterItem[]>([]);
  const [isLoadingPosts, setIsLoadingPosts] = React.useState(false);
  const [postsError, setPostsError] = React.useState<string | null>(null);
  const dispatch = useAppDispatch()

  const { data: projectDetails, statusState } = useAppSelector(selectProjectDetails)
  const processedData = useAppSelector(selectProcessedData);
  const upcomingEvents = processedData?.upcomingEvents || [];
  const pastEvents = processedData?.pastEvents || [];
  const posts = processedData?.posts || [];
  const fundraisingData = processedData?.fundraisingData || [];
  const [imageErrors, setImageErrors] = React.useState<{ [key: string]: boolean }>({});
  // ---------------------------------------------------------------------
  // DATA FETCHING
  // ---------------------------------------------------------------------

  /*const fetchProjectById = async () => {
    setIsLoadingProject(true);
    try {
      const payload = { project_id: projectId ? Number(projectId) : 0 };
      const response = await getProjectByID(payload);
      console.log("Response: ", response)
      setProject(response);

      setPosts(response.posts || []);

      const now = new Date();
      setUpcomingEvents(
        response.activities?.filter(
          (ev: Item) => new Date(ev.start_date_time) >= now
        ) || []
      );
      setPastEvents(
        response.activities?.filter(
          (ev: Item) => new Date(ev.start_date_time) < now
        ) || []
      );

      const campaigns = response.campaigns || [];
      const fundCardData: FundraisingCardProps[] = campaigns.map((c: any) => ({
        name: c.name,
        fundraiserId: c.id,
        //daysLeft: getDaysLeft(c.end_date_time),
        totalAmounts: c.goal,
        currentAmounts: c.total_raised ?? 0,
        totalDonors: c.count_donor ?? 0,
        onClick: () => {
          navigate(`/fundraising/${c.short_id}`);
        },
        onStatsClick: () => {
          navigate(`fundraising/${c.short_id}`);
        },
      }));

      setFundraisingData(fundCardData);
    } catch (error) {
      console.error("Error fetching project data:", error);
    } finally {
      setIsLoadingProject(false);
    }
  };*/

  const fetchEvents = async () => {
    try {
      const endDate = projectDetails?.end_date_time
        ? new Date(projectDetails.end_date_time)
        : new Date("3000-12-31");
      const res = await getEventsToLink(endDate);
      setEventsToLink(res?.data || []);
    } catch (error) {
      console.error("Error fetching events to link:", error);
    }
  };

  const fetchPostsToLink = async () => {
    try {
      if (auth.userId) {
        const response = await getPostsToLink(auth.userId);
        const groups = response.values as GroupData[];

        const transformed: PosterItem[] = groups.flatMap((group) =>
          group.data.map((post) => ({
            id: post.id,
            post_caption: post.post_caption,
            images: post.images.map((img) => ({
              id: img.post_id,
              image_url: img.image_url,
            })),
          }))
        );
        setUserPosts(transformed);
      } else {
        setUserPosts([]);
      }
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  };

  const handleBackToProjects = () => {
    if (publicUserId) {
      navigate(-1);
    } else {
      navigate(`/org/projects`);
    }
  };

  const fetchAllPosts = async () => {
    if (!projectDetails?.id) return;

    setIsLoadingPosts(true);
    setPostsError(null);

    try {
      const response = await getPostsByProject(projectDetails.id);
      setAllPosts(response || []);
    } catch (error) {
      console.error("Error loading posts:", error);
      setPostsError("Failed to load posts");
    } finally {
      setIsLoadingPosts(false);
    }
  };

  // ---------------------------------------------------------------------
  // EFFECTS
  // ---------------------------------------------------------------------

  useEffect(() => {
    if (projectId) {
      dispatch(fetchProjectById(Number(projectId)));
    }
  }, [projectId, dispatch]);

  useEffect(() => {
    fetchPostsToLink();
    fetchEvents();
  }, [auth.userId, projectDetails]);

  useEffect(() => {
    if (!isCreatePostOpen && projectDetails!==null) {
      dispatch(fetchProjectById(Number(projectId)));
    }
  }, [isCreatePostOpen]);

  useEffect(() => {
    fetchAllPosts();
  }, []);

  // ---------------------------------------------------------------------
  // HANDLERS
  // ---------------------------------------------------------------------

  const handleCloseEventPopup = () => {
    setOpenEventPopup(false);
    setSelectedEventItems([]);
  };

  const handleSubmitEventPopup = () => {
    if (selectedEventItems.length > 0) {
      linkEvents({
        projectId: projectDetails?.id ?? 0,
        eventIds: selectedEventItems,
      })
        .catch((err) => console.error(err))
        .then(() => {
          setOpenEventPopup(false);
          setSelectedEventItems([]);
          dispatch(fetchProjectById(Number(projectId)));
        });
    } else {
      setOpenEventPopup(false);
      setSelectedEventItems([]);
    }
  };

  const handleSelectEvent = (itemId: number) => {
    setSelectedEventItems((prev) =>
      prev.includes(itemId)
        ? prev.filter((id) => id !== itemId)
        : [...prev, itemId]
    );
  };

  const handleClosePosterPopup = () => {
    setOpenPosterPopup(false);
    setSelectedPosterItems([]);
  };

  const handleSubmitPostPopup = () => {
    if (selectedPosterItems.length > 0) {
      linkPosts({
        projectId: projectDetails?.id ?? 0,
        postIds: selectedPosterItems,
      })
        .catch((err) => console.error(err))
        .then(() => {
          setOpenPosterPopup(false);
          setSelectedPosterItems([]);
          dispatch(fetchProjectById(Number(projectId)));
        });
    } else {
      setOpenPosterPopup(false);
      setSelectedPosterItems([]);
    }
  };

  const handleSelectPoster = (itemId: number) => {
    setSelectedPosterItems((prev) =>
      prev.includes(itemId)
        ? prev.filter((id) => id !== itemId)
        : [...prev, itemId]
    );
  };
  const handleOnStatsClick = (fundraiserId: string) => {
    navigate(`fundraising/${fundraiserId}`);
  };

  const handleFundraisingCardClick = (fundraiserId: string) => {
    navigate(`/fundraising/${fundraiserId}`);
  };

  const handleImageError = (id: string) => {
  setImageErrors((prev) => ({ ...prev, [id]: true }));
  };


  return (
    // return selectedFundraisingId !== null ? (
    //   <Navigate to={`/fundraising/${selectedFundraisingId}`} replace />
    // ) : (
    <Sections>
      <CenterPageSection>
        <MainContainer>
          <BackButtonContainer>
            <ProjectNavBarBack onClick={handleBackToProjects} />
          </BackButtonContainer>

          { statusState===StatusState.LOADING? (
            <>
              <ProjectHeaderSkeleton />
              <ProjectDetailSkeletonLayout />
            </>
          ) : (
            <>
              <HeaderContainer>
                {openDonationDetail ? (
                  <DonationDetail />
                ) : (
                  <>
                    <ProjectTitle>{projectDetails?.project_name}</ProjectTitle>
                    <TimeRow>
                      <TimeIcon />
                      <ProjectDate>
                        {new Date(
                          projectDetails?.start_date_time!
                        ).toLocaleDateString()}{" "}
                        -{" "}
                        {new Date(projectDetails?.end_date_time!).toLocaleDateString()}
                      </ProjectDate>
                    </TimeRow>
                    <ProjectDescription>
                      {projectDetails?.project_description}
                    </ProjectDescription>
                  </>
                )}
              </HeaderContainer>

              {/* --------------------------------------------------------------
              POPUPS
              -------------------------------------------------------------- */}
              {openEventPopup && (
                <BenevvPopup
                  title="Select Existing Events"
                  open={openEventPopup}
                  onClose={handleCloseEventPopup}
                  onSubmit={handleSubmitEventPopup}
                >
                  <BenevvPopupEvents
                    data={eventsToLink || []}
                    selectedItems={selectedEventItems}
                    handleSelect={handleSelectEvent}
                    emptyMessage="No upcoming events"
                  />
                </BenevvPopup>
              )}

              {openPosterPopup && (
                <BenevvPopup
                  title="Select Existing Posts"
                  open={openPosterPopup}
                  onClose={handleClosePosterPopup}
                  onSubmit={handleSubmitPostPopup}
                >
                  <BenevvPopupPosters
                    posters={userPosts.map((p) => ({
                      id: p.id,
                      image: p.images[0]?.image_url || "",
                      description: p.post_caption || "No caption",
                    }))}
                    selectedItems={selectedPosterItems}
                    handleSelect={handleSelectPoster}
                  />
                </BenevvPopup>
              )}

              <CreatePostModal
                open={isCreatePostOpen}
                onClose={() => setIsCreatePostOpen(false)}
                project_id={projectDetails?.id}
              />

              {/* --------------------------------------------------------------
              MAIN COLUMNS
              -------------------------------------------------------------- */}
              {!openDonationDetail && (
                <ColumnsContainer>
                  {/* ----------------------------------------------------------
                  FUNDRAISING COLUMN
                  ---------------------------------------------------------- */}
                  <ColumnBlock>
                    <SectionHeader>
                      <SectionTitle>Fundraising</SectionTitle>
                      {!publicUserId && <BenevvPopperSelect
                        items={[
                          {
                            text: "Create Fundraising Campaign",
                            onClick: () => {
                              navigate("fundraising/new");
                            },
                          },
                        ]}
                      />}
                    </SectionHeader>

                    <SectionContent style={{ minHeight: "12rem" }}>
                      {fundraisingData && fundraisingData.length > 0 ? (
                        fundraisingData?.map((campaign: ProcessedCampaignInfo, key) => (
                            <FundraisingCard campaign={campaign} onClick={() => {
                              handleFundraisingCardClick(campaign.fundraiserId);
                            }}
                            onStatsClick={() => {
                              handleOnStatsClick(campaign.fundraiserId);
                            }}
                            key={key} />
                        ))
                      ) : (
                        <PlaceholderBox>
                          {!publicUserId && <GreyCircleButton
                            onClick={() => navigate("fundraising/new")}
                          >
                            +
                          </GreyCircleButton>}
                        </PlaceholderBox>
                      )}
                    </SectionContent>
                  </ColumnBlock>

                  {/* ----------------------------------------------------------
                  EVENTS COLUMN
                  ---------------------------------------------------------- */}
                  <ColumnBlock>
                    <SectionHeader>
                      <SectionTitle>Events</SectionTitle>
                      {!publicUserId && <BenevvPopperSelect
                        items={[
                          {
                            text: "Create a new event",
                            onClick: () => {
                              navigate("events/new");
                            },
                          },
                          {
                            text: "Tag an existing event",
                            onClick: () => setOpenEventPopup(true),
                          },
                        ]}
                      />}
                    </SectionHeader>

                    <SectionContent>
                      {/* Upcoming */}
                      <SubSectionTitle>Upcoming Events</SubSectionTitle>
                      {upcomingEvents.length > 0 ? (
                        upcomingEvents.map((ev, idx) => {
                          const start = new Date(ev.start_date_time);
                          const end = new Date(ev.end_date_time);

                          const sameDay =
                            start.getFullYear() === end.getFullYear() &&
                            start.getMonth() === end.getMonth() &&
                            start.getDate() === end.getDate();

                          const startTime = start.toLocaleTimeString([], {
                            hour: "numeric",
                            minute: "2-digit",
                          });
                          const endTime = end.toLocaleTimeString([], {
                            hour: "numeric",
                            minute: "2-digit",
                          });
                          const startDate = start.toLocaleDateString("en-US");
                          const endDate = end.toLocaleDateString("en-US");

                          const formattedTime = sameDay
                            ? `${startTime} - ${endTime}, ${startDate}`
                            : `${startTime}, ${startDate} - ${endTime}, ${endDate}`;

                          return (
                            <StyledEventCard
                              key={idx}
                              onClick={() => setSelectedEvent(ev)}
                            >
                              <EventCardContainer>
                                <EventInfoContainer>
                                  <EventTitle>{ev.activity_title}</EventTitle>
                                  <EventInfoRow>
                                    <AccessTimeIcon
                                      sx={{ color: "#757575", fontSize: 16 }}
                                    />
                                    <EventInfoText>
                                      {formattedTime}
                                    </EventInfoText>
                                  </EventInfoRow>
                                  <EventInfoRow>
                                    <MapIcon
                                      sx={{ color: "#757575", fontSize: 16 }}
                                    />
                                    <EventInfoText>
                                      {ev.places?.[0]?.place_city
                                        ? `${ev.places[0].place_city}, `
                                        : ""}
                                      {ev.places?.[0]?.place_state || ""}
                                      {ev.places?.[0]?.place_postcode
                                        ? ` ${ev.places[0].place_postcode}`
                                        : ""}
                                    </EventInfoText>
                                  </EventInfoRow>
                                </EventInfoContainer>
                              </EventCardContainer>
                            </StyledEventCard>
                          );
                        })
                      ) : (
                        <PlaceholderBox>
                          {!publicUserId && <GreyCircleButton
                            onClick={() => console.log("Crear o vincular algo")}
                          >
                            +
                          </GreyCircleButton>}
                        </PlaceholderBox>
                      )}

                      {/* Past */}
                      <SubSectionTitle style={{ marginTop: "1rem" }}>
                        Past Events
                      </SubSectionTitle>
                      {pastEvents.length > 0 ? (
                        pastEvents.map((ev, idx) => {
                          const start = new Date(ev.start_date_time);
                          const end = new Date(ev.end_date_time);

                          const sameDay =
                            start.getFullYear() === end.getFullYear() &&
                            start.getMonth() === end.getMonth() &&
                            start.getDate() === end.getDate();

                          const startTime = start.toLocaleTimeString([], {
                            hour: "numeric",
                            minute: "2-digit",
                          });
                          const endTime = end.toLocaleTimeString([], {
                            hour: "numeric",
                            minute: "2-digit",
                          });
                          const startDate = start.toLocaleDateString("en-US");
                          const endDate = end.toLocaleDateString("en-US");

                          const formattedTime = sameDay
                            ? `${startTime} - ${endTime}, ${startDate}`
                            : `${startTime}, ${startDate} - ${endTime}, ${endDate}`;

                          return (
                            <StyledEventCard
                              key={idx}
                              onClick={() => setSelectedEvent(ev)}
                            >
                              <EventCardContainer>
                                <EventInfoContainer>
                                  <EventTitle>{ev.activity_title}</EventTitle>
                                  <EventInfoRow>
                                    <AccessTimeIcon
                                      sx={{ color: "#757575", fontSize: 16 }}
                                    />
                                    <EventInfoText>
                                      {formattedTime}
                                    </EventInfoText>
                                  </EventInfoRow>
                                  <EventInfoRow>
                                    <MapIcon
                                      sx={{ color: "#757575", fontSize: 16 }}
                                    />
                                    <EventInfoText>
                                      {ev.places?.[0]?.place_city
                                        ? `${ev.places[0].place_city}, `
                                        : ""}
                                      {ev.places?.[0]?.place_state || ""}
                                      {ev.places?.[0]?.place_postcode
                                        ? ` ${ev.places[0].place_postcode}`
                                        : ""}
                                    </EventInfoText>
                                  </EventInfoRow>
                                </EventInfoContainer>
                              </EventCardContainer>
                            </StyledEventCard>
                          );
                        })
                      ) : (
                        <PlaceholderBox>
                          {!publicUserId && <GreyCircleButton
                            onClick={() => console.log("Crear o vincular algo")}
                          >
                            +
                          </GreyCircleButton>}
                        </PlaceholderBox>
                      )}
                    </SectionContent>
                  </ColumnBlock>

                  {/* ----------------------------------------------------------
                  POSTS COLUMN
                  ---------------------------------------------------------- */}
                  <ColumnBlock>
                    <SectionHeader>
                      <SectionTitle>Posts</SectionTitle>
                      {!publicUserId && <BenevvPopperSelect
                        items={[
                          {
                            text: "Create a new post",
                            onClick: () => setIsCreatePostOpen(true),
                          },
                          {
                            text: "Tag an existing post",
                            onClick: () => setOpenPosterPopup(true),
                          },
                        ]}
                      />}
                    </SectionHeader>

                    <SectionContent>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          padding: "2% 2% 0 2%",
                        }}
                      >
                        <SeeAllLink
                          onClick={() => {
                            if (allPosts.length === 0) {
                              setIsLoadingPosts(true);
                              fetchAllPosts().finally(() =>
                                setViewPostsModalOpen(true)
                              );
                            } else {
                              setViewPostsModalOpen(true);
                            }
                          }}
                        >
                          {isLoadingPosts ? "Loading..." : "see all"}
                        </SeeAllLink>
                      </div>

                      {posts.length > 0 ? (
                        <PostersContainer style={{ marginTop: "0.5rem" }}>
                          {posts.map((p) => (
                            <PosterCard
                              onClick={() => navigate(`/post/${p.id}`)}
                              key={p.id}
                              style={{
                                width: "48%",
                                marginBottom: "0.5rem",
                                cursor: "pointer",
                              }}
                            >
                              {!imageErrors[p.id.toString()] && p.images[0]?.image_url ? (
                                <PosterImage
                                  src={p.images[0].image_url}
                                  onError={() => handleImageError(p.id.toString())}
                                />
                              ) : (
                                <PosterImageFallback>No Image Found</PosterImageFallback>
                              )}
                              <PosterCaption>{p.post_caption}</PosterCaption>
                            </PosterCard>
                          ))}
                        </PostersContainer>
                      ) : (
                        <PlaceholderBox>
                          {!publicUserId && <GreyCircleButton
                            onClick={() => console.log("Crear o vincular algo")}
                          >
                            +
                          </GreyCircleButton>}
                        </PlaceholderBox>
                      )}
                    </SectionContent>
                  </ColumnBlock>
                </ColumnsContainer>
              )}

              {/* --------------------------------------------------------------
              VIEW POSTS MODAL
              -------------------------------------------------------------- */}
              {viewPostsModalOpen && (
                <ViewPostsModal
                  posts={allPosts.map((post) => ({
                    id: post.id,
                    imageUrl: post.images[0]?.image_url || "",
                    description: post.post_caption,
                  }))}
                  isLoading={isLoadingPosts}
                  error={postsError}
                  onClose={() => {
                    setViewPostsModalOpen(false);
                    setPostsError(null);
                  }}
                />
              )}

              {/* --------------------------------------------------------------
              EVENT DETAIL MODAL
              -------------------------------------------------------------- */}
              {selectedEvent && (
                <EventDetailModal
                  event={selectedEvent}
                  onClose={() => setSelectedEvent(null)}
                />
              )}
            </>
          )}
        </MainContainer>
      </CenterPageSection>
    </Sections>
  );
};

export default ProjectMainBoard;
